import { render, staticRenderFns } from "./aceEditorJson.vue?vue&type=template&id=f4f5e06c"
import script from "./aceEditorJson.vue?vue&type=script&lang=js"
export * from "./aceEditorJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports